import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const FlyingBeeBy100s = () => {
  const [qIndex, setQIndex] = useState(0);
  const [answer, setAnswer] = useState(200);
  const [feedback, setFeedback] = useState('');

  const correctSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg'));
  const wrongSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg'));

  const questions = [
    { q: "Bee starts at 0 and flies 2 flowers ahead. Where is she?", a: 200 },
    { q: "Quick! 100 more than 400?", a: 500 },
    { q: "Which flower has a number ending in 00?", a: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000] },
    { q: "If Bee skips 3 flowers starting from 100, where will she land?", a: 400 },
    { q: "Bee flies to the 7th flower. Where is she?", a: 700 },
    // New skip counting by 100 questions
    { q: "Bee starts at 0 and skips 5 flowers. Where will she land?", a: 500 },
    { q: "Bee is at 300. Skip 4 flowers ahead. Where is she now?", a: 700 },
    { q: "Which flower comes 3 skips after 200?", a: 500 },
    // { q: "Bee flies 10 flowers ahead from 400. Where is she?", a: 1400 },
    { q: "Skip counting by 100 starting at 0, what is the 9th flower?", a: 900 },
    { q: "Bee wants to land on a flower number ending in 00 after 6 skips from 100. Which flower is it?", a: 700 },
    { q: "If Bee skips 8 flowers starting from 200, where will she land?", a: 1000 },
    { q: "Bee starts at 500 and skips 2 flowers. Where is she?", a: 700 },
    { q: "Which flower is 100 more than 600?", a: 700 },
    // { q: "Bee wants to fly to the 12th flower. Where is she?", a: 1200 }
  ];


  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive, sans-serif",
      backgroundColor: '#f3e5f5',
      textAlign: 'center',
      padding: '2rem',
      minHeight: '100vh',
      boxSizing: 'border-box'
    },
    h1: {
      color: '#9c27b0',
      marginBottom: '1.5rem',
      fontSize: '2rem'
    },
    question: {
      margin: '2rem 0',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      maxWidth: '600px',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    field: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginTop: '2rem',
      gap: '0.8rem',
      maxWidth: '90vw',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    flower: {
      width: 'min(14vw, 70px)',
      height: 'min(14vw, 70px)',
      borderRadius: '50%',
      backgroundColor: '#e1bee7',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      border: '2px solid #6a1b9a',
      position: 'relative'
    },
    result: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      color: 'green',
      marginTop: '2rem',
      minHeight: '2rem'
    },
  };

  const handleAnswer = (selected) => {
  const correct = questions[qIndex].a;

  const isCorrect = Array.isArray(correct)
    ? correct.includes(selected)
    : selected === correct;

  if (isCorrect) {
    correctSound.current.play();
    setFeedback("✅ Yay! Bee landed on the right flower!");

    setTimeout(() => {
      const next = qIndex + 1;

      if (next < questions.length) {
        setQIndex(next);
        setAnswer(questions[next].a);
        setFeedback('');
      } else {
        // No more questions
        setFeedback("🎉 You finished all Bee jumps!");
      }
    }, 1500);

    const responsedata = ConstructorEventUpdateSQLStatus();
    console.log("Event completed", responsedata);
  } else {
    wrongSound.current.play();
    setFeedback("❌ Oops! Try a different flower!");
  }
};



  useEffect(() => {
    setAnswer(questions[qIndex].a);
  }, [qIndex]);

  return (
    <div style={styles.body}>
      <h2 style={styles.h1}>🐝 Flying Bee by 100s</h2>
      <p>Help Bee land on the right flower by counting by 100s!</p>

      <div style={styles.question}>
        {qIndex >= questions.length
          ? "🎉 You finished all Bee jumps!"
          : questions[qIndex].q}
      </div>

      <div style={styles.field}>
        {Array.from({ length: 11 }).map((_, i) => {
          const value = i * 100;
          const isSparkle = value % 200 === 0;
          return (
            <div
              key={value}
              style={{ ...styles.flower }}
              onClick={() => handleAnswer(value)}
            >
              {value}
              {isSparkle && (
                <span
                  style={{
                    position: 'absolute',
                    top: '-10px',
                    right: '-10px',
                  }}
                >
                  ✨
                </span>
              )}
            </div>
          );
        })}
      </div>

      <div style={styles.result}>{feedback}</div>
    </div>
  );
};

export default FlyingBeeBy100s;
